<script>
/* eslint-disable no-console */
import NewForm from './New'
export default {
  mixins: [NewForm],
  data() {
    return {
      valid: null,
      id: null,
      root: {},
      form: [
        { label: '品種グループ名', name: 'name', required: true, isId: true },
      ],
    }
  },
  methods: {
    load() {
      this.$http
        .get(`/product-groups/${this.$route.query.name}`)
        .then((res) => {
          this.root = res.data
        })
    },
    save() {
      this.$http
        .put(`/product-groups`, this.root)
        .then(() => {
          this.returnToList()
          this.$message('', 'Success')
        })
        .catch(() => {
          this.$message('', 'Error')
        })
    },
    returnToList() {
      this.$router.push({
        name: 'M0270',
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
